import { render, staticRenderFns } from "./goldsilverout.vue?vue&type=template&id=04ef5622&scoped=true&"
import script from "./goldsilverout.vue?vue&type=script&lang=js&"
export * from "./goldsilverout.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverout.vue?vue&type=style&index=0&id=04ef5622&scoped=true&lang=scss&"
import style1 from "./goldsilverout.vue?vue&type=style&index=1&lang=css&"
import style2 from "./goldsilverout.vue?vue&type=style&index=2&id=04ef5622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef5622",
  null
  
)

export default component.exports